import React, { useState } from "react";

import { WarningFilled, CloseOutlined, CheckOutlined } from "@ant-design/icons";
import "./confirmation_modal.less";
import { Button, Col, Modal, Radio, Row } from "antd";
import TrashIcon from "@src/assets/icons/trash.svg";

function ConfirmationModal({
  action,
  setModalVisible,
  modalVisible,
  modalMessage,
}) {
  const [acceptDelete, setAcceptDelete] = useState(false);

  const handleOk = () => {
    if (modalMessage.selectedRowToDelete) {
      action(modalMessage.selectedRowToDelete);
    } else {
      action();
    }

    setModalVisible(false);
  };

  const button =
    modalMessage?.btnType === "danger" ? (
      <Button type="primary" icon={<TrashIcon />} danger onClick={handleOk}>
        {" "}
        {modalMessage.button}
      </Button>
    ) : (
      <Button type="primary" icon={<CheckOutlined />} onClick={handleOk}>
        {" "}
        {modalMessage.button}
      </Button>
    );

  return (
    <>
      <Modal
        data-testid="confirmation-modal"
        width="30%"
        open={modalVisible}
        centered
        className="confirmation-modal"
        title={modalMessage.title}
        closable={false}
        bodyStyle={{ width: "100%" }}
        footer={
          <>
            <Button
              onClick={() => setModalVisible(false)}
              icon={<CloseOutlined />}
            >
              Cancel
            </Button>
            {!acceptDelete && modalMessage.hasInRecruitmentStatus ? (
              <Radio
                data-testid="doubleCheckRB"
                onClick={() => setAcceptDelete(true)}
                value={true}
              >
                Yes, I double checked it.
              </Radio>
            ) : (
              button
            )}
          </>
        }
      >
        <div className="warning-row">
          <WarningFilled className="warning-icon" />
          <div>{modalMessage.warning}</div>
        </div>
      </Modal>
    </>
  );
}

export default ConfirmationModal;
